import styled from 'styled-components'

const IconStyled = styled.div`
  position: absolute;
  top: var(--icon-advanced-view-top);
  left: var(--icon-advanced-view-left);
`

export { IconStyled }
